module.exports = __webpack_public_path__ + "img/CUADRO_Esp-Tecnicas-MSU3.ea4c27d1.png";